import axios from "axios";

export const fetchFacilities = () => {
  return (dispatch) => {
    axios.get("/facilities").then((response) => {
      dispatch({
        type: "FETCH_FACILITIES",
        facilities: response.data,
      });
    });
  };
};

export const addFacilityWithDetails = (formData) => {
  return async (dispatch, getState) => {
    const updatedFacility = {
      ...formData.facility,
      emc_participant_id: "EA2DBC4EEB5E01FEE0530A020A0B66ED"
    }

    const createdFacility = await dispatch(addFacility(updatedFacility));
    const buildingName = formData.tableBuildingParameter.building_name;

    const updatedTableNames = formData.tableNames.map(({asset_name, db_id, ...rest}) => ({
      ...rest,
      table_name: `log_${buildingName}_${asset_name}`,
      thing_name: `${buildingName}_${asset_name}`,
      facility_id: createdFacility.id
    }));

    await axios.post("/table_names/new", updatedTableNames);
    await axios.post("/table_building_parameters/new", formData.tableBuildingParameter);
  }
}

export const addFacility = (facility) => {
  return async (dispatch, getState) => {
    const response = await axios.post("/facilities/new", facility);
    dispatch({
      type: "ADD_FACILITY",
    });
    dispatch(fetchFacilities());
    return response.data; 
  };
};

export const updateFacilityWithDetails = (formData) => {
  return async (dispatch, getState) => {
    await dispatch(updateFacility(formData.facility));
    await syncTableNamesForFacility(formData.facility.id, formData);

    const tableBuildingParameter = formData.tableBuildingParameter;
    await axios.put("/table_building_parameters/" + tableBuildingParameter.id, tableBuildingParameter);
  };
};

const syncTableNamesForFacility = async (facilityId, formData) => {
  const tableNamesResponse = await axios.get("/table_names/facility/" + facilityId);
  const dbTableNameIds = tableNamesResponse.data.map(({ id }) => id);
  const buildingName = formData.tableBuildingParameter.building_name;

  // Split form data based on whether table names exist in db (does db_id exist?)
  const { formTableNamesMap, newTableNames } = formData.tableNames.reduce(
    (acc, item) => {
      if (item.db_id) {
        acc.formTableNamesMap[item.db_id] = item;  
      } else {
        acc.newTableNames.push(item);           
      }
      return acc;
    },
    { formTableNamesMap: {}, newTableNames: [] }
  );

  // Add new table names
  const updatedNewTableNames = newTableNames.map(({asset_name, db_id, ...rest}) => ({
    ...rest,
    table_name: `log_${buildingName}_${asset_name}`,
    thing_name: `${buildingName}_${asset_name}`,
    facility_id: facilityId
  }));

  updatedNewTableNames.forEach(async (tableName) => {
    await axios.post("/table_names/new", tableName);
  });

  // Update existing table names
  // If dbid is in formTableNamesMap, update the entry. Else, delete dbid entry
  const updatedFormTableNamesMap = Object.entries(formTableNamesMap).reduce((acc, [id, item]) => {
    const { asset_name, db_id, ...rest } = item;
    acc[id] = {
      ...rest,
      table_name: `log_${buildingName}_${asset_name}`,
      thing_name: `${buildingName}_${asset_name}`,
    };
    return acc;
  }, {});

  dbTableNameIds.forEach(async (dbTableNameId) => {
    if (dbTableNameId in updatedFormTableNamesMap) {
      const tableName = updatedFormTableNamesMap[dbTableNameId];
      await axios.put("/table_names/" + dbTableNameId, tableName);
    } else {
      await axios.delete("/table_names/" + dbTableNameId);
    }
  });
};

export const updateFacility = (facility) => {
  return (dispatch) => {
    axios.put("/facilities/" + facility.id, facility).then(() => {
      dispatch({
        type: "UPDATE_FACILITY",
      });
      dispatch(fetchFacilities());
    });
  };
};

export const removeFacility = (id) => {
  return (dispatch) => {
    axios.delete("/facilities/" + id).then(() => {
      dispatch({
        type: "REMOVE_FACILITY",
      });
      dispatch(fetchFacilities());
    });
  };
};

export const selectFacility = (facility) => {
  return (dispatch) => {
    dispatch({
      type: "SELECT_FACILITY",
      facility,
    });
  };
};
